module.exports = __webpack_public_path__ + "static/img/bg1.0ef24a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/bg1.png
// module id = 2+oM
// module chunks = 1